import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, Button, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../../core/user/userApi';
import './resetPasswordForm.scss';
import { FinishedFailedProps, valuesProps, ResetPasswordFormProps } from './types';
import { AppDispatch, CombinedStates } from '../../../core/types';

const ResetPasswordForm:FC<ResetPasswordFormProps> = () => {
    const dispatch = useDispatch<AppDispatch>();
    const {
        isFetching,
    } = useSelector((state:CombinedStates) => state.user);
    const { token, email } = useParams();
    const [form] = Form.useForm();

    const onFinish = (values: valuesProps) => {
        dispatch(resetPassword({
            email,
            password: values.newPassword,
            passwordConfirmation: values.confirmPassword,
            token,
        }));
    };

    const onFinishFailed = ({ errorFields }:FinishedFailedProps) => {
        form.scrollToField(errorFields[0]?.name);
    };

    return (

        <div className="login-form-box">
            <div className="form">
                <h3 className="form-title h-1">Atstatyti slaptažodį</h3>
                <Form onFinish={onFinish} onFinishFailed={onFinishFailed} layout="vertical">
                    <Form.Item label="Naujas slaptažodis" name="newPassword" rules={[{ required: true, message: 'Įveskite naują slaptažodį.' }]}>
                        <Input.Password />
                    </Form.Item>
                    <Form.Item label="Pakartokite slaptažodį"
                        name="confirmPassword"
                        dependencies={['newPassword']}
                        rules={[
                            { required: true, message: 'Pakartokite slaptažodį.' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject(new Error('Įvesti slaptažodžiai nesutampa!'));
                                },
                            }),
                        ]}>
                        <Input.Password />
                    </Form.Item>
                    <Row>
                        <Col xs={24}>
                            <Button type="primary" size="large" block htmlType="submit" className="wide" loading={isFetching}>
                                Atstatyti slaptažodį
                            </Button>
                        </Col>
                    </Row>

                </Form>
            </div>
        </div>

    );
};

export default ResetPasswordForm;
